import Cookies from "js-cookie"

import { IS_NA, IS_CA, IS_US, IS_INT, IS_UK } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()
  const geoCookie = Cookies.get("geo")
  const isGeoUS = geoCookie ? geoCookie === "US" : IS_US()
  const isGeoCA = geoCookie ? geoCookie === "CA" : IS_CA()

  return () => {
    try {
      if (IS_NA() && (isGeoUS || isGeoCA)) {
        const attentiveBoxID = isMobile
          ? isGeoUS
            ? 1362760 // US Mobile
            : 1362771 // CA Mobile
          : isGeoUS
            ? 1362758 // US Desktop
            : 1362770 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        // const lightboxID = IS_UK()
        //   ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
        //   : "acb91908-2c05-44ab-a719-47b5633fff8e" // 325686
        const lightboxID = IS_INT()
          ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
          : IS_UK()
            ? "12e682df-8816-43a9-92b8-1ada528ab378" // 327631
            : "58602e79-1c74-4680-8adb-2697bb416cc6" // 327659
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

export default usePopupTrigger
